export default __webpack_public_path__ + "static/media/Pete_Wilders.7398ad6c.jpg";